export default __webpack_public_path__ + "d843ce55bb9493d461a99abb30a6c4da.svg";